import ArticlesPage from 'views/articles/ArticlesPage';

export default ArticlesPage;
